import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';



export const AuthContext = createContext();

export const useAuthContext = () => {
  return useContext(AuthContext)
}

export const AuthProvider = ({ children }) => {
  const [email, setEmail] = React.useState("");
  const flowChangerToken = Cookies.get('flowChangerAuthToken')
  const [isAuthenticated, setIsAuthenticated] = useState(flowChangerToken ? true : false);
  const [step, setStep] = useState(1);
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [userRole, setUserRole] = useState(null);
  // states to handle step5
  const [timeZone, setTimeZone] = useState(null);
  const [timeFormate, setTimeFormate] = useState("");
  const [dateFormate, setDateFormate] = useState("");
  const [weekFormate, setWeekFormate] = useState("");

  const [adminInfo, setAdminInfo] = useState({
    email: '',
    first_name: '',
    last_name: '',
    mobile: '+91',
    password: '',
  });
  console.log(adminInfo)
  const [extraInfo, setExtraInfo] = useState({
    time_formate: '',
    time_zone: '',
    date_formate: '',
    week_formate: '',
    package_id: '',
    company_name: '',
    profile_image: '',
    company_logo: '',
    email: ''
  });
  console.log(extraInfo);
  const updateExtraInfo = (data) => {
    setExtraInfo(prev => {
      const newExtraInfo = { ...prev, ...data };
      return newExtraInfo;
    });
  }

  const updateAdminInfo = (data) => {
    console.log(data);
    setAdminInfo(prev => ({ ...prev, ...data }));
  };


  const nextStep = () => setStep(prev => prev + 1);
  const prevStep = () => setStep(prev => prev - 1);


  return (
    <AuthContext.Provider value={{
      flowChangerToken,
      step,
      setStep,
      setIsAuthenticated,
      adminInfo,
      extraInfo,
      isAuthenticated,
      setTimeZone,
      timeZone,
      timeFormate,
      dateFormate,
      weekFormate,
      setTimeFormate,
      setWeekFormate,
      setDateFormate,
      updateAdminInfo,
      updateExtraInfo,
      user,
      setUser,
      nextStep,
      prevStep,
      profile,
      setProfile,
      email,
      setEmail
    }}>
      {children}
    </AuthContext.Provider>
  );
};
export default AuthProvider;